import { useTranslation } from "react-i18next";
import { useAdminLang } from "../contexts/AdminLangContext";

/**
 * Returns a t() function fixed to the current admin language.
 * All admin UI strings should use this instead of the global useTranslation hook,
 * so the admin panel can have an independent language from the public-facing site.
 */
export function useAdminT() {
  const { i18n } = useTranslation();
  const { adminLang } = useAdminLang();
  return i18n.getFixedT(adminLang);
}
